import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { FormValues } from '../data/discoveryForm';
export const inputClassName = 'mt-2 w-full rounded-sm border border-stone-300 bg-white px-3.5 py-3 text-sm text-[#172820] outline-none transition placeholder:text-stone-400 focus:border-[#286151] focus:ring-2 focus:ring-[#a8d5c3]';
export function fieldClassName(hasError: boolean) {
  return `${inputClassName} ${hasError ? 'border-[#b7543e] focus:border-[#b7543e] focus:ring-[#edc2b8]' : ''}`;
}
type FormSectionProps = {
  number: string;
  title: string;
  description: string;
  children: React.ReactNode;
};
export function FormSection({
  number,
  title,
  description,
  children
}: FormSectionProps) {
  return <fieldset className="border-t border-stone-200 pt-8" data-id="element-61" data-mp="2sng5r42ehigp">
      <legend className="w-full" data-id="element-62" data-mp="24ydp9zji5vns">
        <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#286151]" data-id="element-63" data-mp="24xlwewhaic17">
          {number}
        </span>
        <span className="mt-2 block text-xl font-semibold tracking-tight text-[#172820]" style={{
        fontFamily: 'var(--font-display)'
      }} data-id="element-64" data-mp="1zzaj2brsdje8">
          {title}
        </span>
        <span className="mt-1 block text-sm leading-6 text-stone-600" data-id="element-65" data-mp="3k53tw3bohvb7">
          {description}
        </span>
      </legend>
      <div className="mt-6" data-id="element-66" data-mp="3szigkqyjg84c">{children}</div>
    </fieldset>;
}
type FieldProps = {
  label: string;
  field: keyof FormValues;
  required?: boolean;
  helper?: string;
  error?: string;
  children: React.ReactNode;
};
export function Field({
  label,
  field,
  required = false,
  helper,
  error,
  children
}: FieldProps) {
  return <div data-id="element-67" data-mp="359eh8vsduuj5">
      <label htmlFor={field} className="text-sm font-semibold text-[#172820]" data-id="element-68" data-mp="358ml9juviusc">
        {label}
        {required && <span className="ml-1 text-[#b7543e]" aria-label="required" data-id="element-69" data-mp="3a767zmhakalr">
            *
          </span>}
      </label>
      {helper && <p className="mt-1 text-xs leading-5 text-stone-500" data-id="element-70" data-mp="pi8r2qxnqymi">{helper}</p>}
      {children}
      {error && <p id={`${field}-error`} className="mt-2 text-sm font-medium text-[#b7543e]" data-id="element-71" data-mp="2lkvbcewkhg9u">
          {error}
        </p>}
    </div>;
}
type SelectProps = {
  id: keyof FormValues;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: boolean;
  children: React.ReactNode;
};
export function Select({
  id,
  name,
  value,
  onChange,
  error = false,
  children
}: SelectProps) {
  return <div className="relative" data-id="element-72" data-mp="1xx3yna747181">
      <select id={id} name={name} value={value} onChange={onChange} className={`${inputClassName} appearance-none pr-10 ${error ? 'border-[#b7543e] focus:border-[#b7543e] focus:ring-[#edc2b8]' : ''}`} aria-invalid={error} aria-describedby={error ? `${id}-error` : undefined} data-id="element-73" data-mp="1xxx13yz1j4kd">
        {children}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-500" aria-hidden="true" data-id="element-74" data-mp="1f6w25axx790t" />
    </div>;
}